module.exports = __webpack_public_path__ + "static/media/hero.513c3cd5.png";